import { Box, css, IconButton, styled } from '@mui/material';

export const SModalContainer = styled(Box)(
  ({ theme }) => css`
    background-color: ${theme.palette.common.white};
    border-radius: 20px;
    width: 100%;
  `,
);

export const SHeader = styled(Box)(
  () => css`
    display: flex;
    flex-direction: column;
    gap: 16px;
    padding: 24px 24px 16px;
    border-top-left-radius: 20px;
    border-top-right-radius: 20px;
  `,
);

export const SHeaderTop = styled(Box)(
  () => css`
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
  `,
);

export const SCloseButton = styled(IconButton)(
  ({ theme }) => css`
    color: ${theme.palette.grey[500]};
    height: 24px;
    padding: 0;
    width: 24px;
  `,
);

export const SContent = styled(Box)(
  () => css`
    display: flex;
    flex-direction: column;
    gap: 20px;
    padding: 0 24px;
  `,
);

export const SPlanSection = styled(Box)(
  () => css`
    display: flex;
    flex-direction: column;
    gap: 4px;
  `,
);

export const SNewPlanSection = styled(Box)(
  () => css`
    display: flex;
    flex-direction: column;
    gap: 16px;
  `,
);

export const SBoosterIncludedCard = styled(Box)(
  ({ theme }) => css`
    display: flex;
    gap: 10px;
    padding: 16px;
    background-color: ${theme.palette.grey[50]};
    border: 1px solid ${theme.palette.grey[200]};
    border-radius: 12px;
  `,
);

export const SBoosterContent = styled(Box)(
  () => css`
    display: flex;
    flex-direction: column;
    gap: 2px;
    flex: 1;
  `,
);

export const SActions = styled(Box)(
  () => css`
    display: flex;
    flex-direction: column;
    gap: 12px;
    padding: 24px;
  `,
);
